import React, { useContext } from "react";

// Import Contexts
import { LanguageContext, ScreenContext } from "contexts";

// Import Components
import {
  TitleBar,
  BodyScanInstructions,
  PrimaryButton,
} from "components/index";
import { Language, TScreen, TScreenContext } from "api/type";
import { getTranslation } from "utils/translate";

type ScreenScanInstructionsProps = {};

const ScreenScanInstructions: React.FC<ScreenScanInstructionsProps> = () => {
  // Context
  const language = useContext<Language>(LanguageContext)[0];
  const setScreen = useContext<TScreenContext>(ScreenContext)[1];

  return (
    <div className="screen-container">
      <TitleBar
        name={getTranslation("scanInstructions", language)}
        onClickBackButton={null}
        centerTitle
        showLogo={false}
      />
      <BodyScanInstructions />
      <PrimaryButton
        onClick={() => {
          setScreen(TScreen.BODY_SCAN_SCREEN);
        }}
        fullWidth
        text={getTranslation("continue", language)}
      />
    </div>
  );
};

export default ScreenScanInstructions;
